import { render, staticRenderFns } from "./CalendarEventDetailModal.vue?vue&type=template&id=0d8f25a3&scoped=true&"
import script from "./CalendarEventDetailModal.vue?vue&type=script&lang=js&"
export * from "./CalendarEventDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./CalendarEventDetailModal.vue?vue&type=style&index=0&id=0d8f25a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8f25a3",
  null
  
)

export default component.exports